<template>
  <div class="overlay">
    <Loading :isProcessing="isProcessing"></Loading>    
    <div class="content">
      <table class="table">
        <tbody>
          <tr>
            <th>有効期間</th>
            <td>
              {{ this.notice.fromDt }}～{{ this.notice.toDt }}
            </td>
          </tr>
          <tr>
            <th>タイトル</th>
            <td>
              {{ this.notice.title }}
            </td>
          </tr>
          <tr>
            <th>本文</th>
            <td>
              {{ this.notice.content }}
            </td>
          </tr>
        </tbody>
        <button @click="close()">閉じる</button>
      </table>
    </div>
  </div>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      isProcessing: false,
      notice: {
        fromDt: null,
        toDt: null,
        title: null,
        content: null,
      },
    }
  },
  methods: {
    async getNotice(noticeId) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/notice/edit', {
        noticeId: noticeId,
      });
      if (res) {
        this.notice = res.data.notice;
      }
      this.isProcessing = false;
    },
    close() {
      this.notice = {
        fromDt: null,
        toDt: null,
        title: null,
        content: null,
      };
      this.$emit("close-notice-detail");
    },
  }
}
</script>

<style>
.content {
  z-index:10;
  width:50%;
  padding: 1em;
  background:#fff;
}

.overlay {
  z-index:1;
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>